import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailReferralComponent } from '../../components/email-referral/email-referral.component';
import type { Language } from '../../components/email-referrals-logo/email-referrals-logo.component';
import { EmailReferralsLogoComponent } from '../../components/email-referrals-logo/email-referrals-logo.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-referral-application-confirmation-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './referral-application-confirmation.component.html',
  imports: [
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailReferralsLogoComponent,
    EmailReferralComponent,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class ReferralApplicationConfirmationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<ReferralApplicationConfirmationTemplateData>;
}

export type ReferralApplicationConfirmationTemplateData = {
  title: string;
  p1_false: string;
  p1_true_html: string;
  job_button_text: string;
  job_button_link: string;
  status_button_text: string;
  referrals_button_link: string;
  candidate_name: string;
  offer_title: string;
  referral_status_visible: boolean;
  language: Language;
};

export const ReferralApplicationConfirmationTemplateMocks: ReferralApplicationConfirmationTemplateData[] =
  [
    {
      title: 'Your referral was successfully submitted!',
      p1_false:
        "Recruiters have been notified about your referral. To follow the referral's status, please contact the hiring team.",
      p1_true_html:
        'Recruiters have been notified about your referral. To follow the referral\'s status, visit the Referrals section or click "Check status" below.',
      job_button_text: 'Go to job',
      job_button_link: 'http://google.pl/',
      status_button_text: 'Check status',
      referrals_button_link: 'http://google.pl/',
      candidate_name: 'Jordan Ntolo',
      offer_title: 'Product Designer',
      referral_status_visible: true,
      language: {
        en: true,
        de: false,
        fr: false,
        nl: false,
        sv: false,
        fi: false,
      },
    },
  ];
